import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { activityApi, type ActivityLogParams } from "@/lib/api/services/activity.api";

/**
 * The current user's activity log (self-scoped by default; org-wide when the
 * caller holds `audit:read` and passes filters). Keeps previous data while
 * paging so the table doesn't flash empty between pages.
 */
export function useActivityLog(params: ActivityLogParams, enabled = true) {
  return useQuery({
    queryKey: ["activity-log", params],
    queryFn: () => activityApi.paginate(params),
    enabled,
    placeholderData: keepPreviousData,
  });
}
